import { ChevronLeft, ChevronRight } from 'lucide-react';
import { num } from '../lib/format';
import { Button, Select } from './Form';

export function Pagination({
  page,
  limit,
  total,
  count,
  onPage,
  onLimit,
  limits = [25, 50, 100, 200],
}: {
  page: number;
  limit: number;
  /** Absent when the endpoint does not return a total (e.g. /admin-api/audit). */
  total?: number;
  count: number;
  onPage: (page: number) => void;
  onLimit?: (limit: number) => void;
  limits?: number[];
}) {
  const pages = total !== undefined ? Math.max(1, Math.ceil(total / limit)) : undefined;
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = (page - 1) * limit + count;
  const hasNext = pages !== undefined ? page < pages : count >= limit;

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <div className="tabular text-xs text-zinc-500">
        {total !== undefined
          ? `${num(from)}–${num(to)} из ${num(total)}`
          : `строки ${num(from)}–${num(to)}`}
        {pages !== undefined ? ` · стр. ${num(page)} / ${num(pages)}` : ''}
      </div>
      <div className="flex items-center gap-2">
        {onLimit ? (
          <Select
            className="h-8 w-auto py-0 text-xs"
            value={limit}
            onChange={(event) => onLimit(Number(event.target.value))}
            aria-label="Строк на странице"
          >
            {limits.map((value) => (
              <option key={value} value={value}>
                {value} / стр.
              </option>
            ))}
          </Select>
        ) : null}
        <Button
          size="sm"
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          icon={<ChevronLeft className="size-3.5" />}
        >
          Назад
        </Button>
        <Button size="sm" disabled={!hasNext} onClick={() => onPage(page + 1)}>
          Вперёд
          <ChevronRight className="size-3.5" />
        </Button>
      </div>
    </div>
  );
}
